<template>
  <div>
    <v-text-field
      style="width:95%;"
      v-model.trim="searchText"
      :type="valueType"
      class="mt-4"
      outlined
      clearable
      :hint="hint"
      :label="label"
      prepend-inner-icon="search"
      append-outer-icon="search"
      v-on:keyup.enter.prevent="action(searchText)"
      @click:append-outer.prevent="action(searchText)"
    ></v-text-field>
  </div>
</template>
<script>
export default {
  props: {
    valueType: {
      default: "text",
      // type: String,
    },
    action: {
      type: Function,
    },
    vModel: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      searchText: this.vModel,
    };
  },
  computed: {
    hint() {
      return "Enter your " + this.type + " and click the search icon";
    },
    label() {
      return "Enter " + this.type;
    },
  },
};
</script>
